var _path, _polygon, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDebriefing(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.484,12.111c0-0.242-0.14-0.448-0.345-0.55c0.001-0.044-0.01-0.081-0.035-0.106l-3.213-3.212 c-0.098-0.099-0.378,0.019-0.618,0.259s-0.36,0.517-0.259,0.618l2.372,2.372H6.765c-0.34,0-0.62,0.28-0.62,0.62 c0,0.34,0.27,0.62,0.62,0.62h9.642l-2.351,2.351c-0.098,0.098,0.02,0.377,0.26,0.617s0.517,0.359,0.617,0.26l3.213-3.213 c0.026-0.026,0.035-0.066,0.032-0.113C18.357,12.523,18.484,12.334,18.484,12.111z"
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    points: "13.68,14.792 13.682,14.79 13.682,14.79  "
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M19.902,17.75c-0.043,1.202-1.02,2.16-2.232,2.16H6.32c-1.23,0-2.24-1-2.24-2.24V6.32c0-1.23,1-2.24,2.24-2.24v0.01h11.35 c1.24,0,2.24,1,2.24,2.24v0.357h2.08V6.33c0-2.39-1.93-4.33-4.32-4.33H6.32C3.93,2.01,1.99,3.94,1.99,6.33v11.35 C2,20.061,3.93,22,6.32,22h11.35v0.01c2.355-0.01,4.274-1.902,4.313-4.26H19.902z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDebriefing);
export default __webpack_public_path__ + "static/media/debriefing.c2d15affd56fdc9e3de1cd0890fc49d6.svg";
export { ForwardRef as ReactComponent };